module.exports = __webpack_public_path__ + "static/media/volontar-logo-super-light.d5916c04.svg";